<div class="riportok">

  <!-- Fejléc + szűrők -->
  <div class="rip-head">
    <div class="rip-head__text">
      <h1 class="stk-page-title">Riportok</h1>
      <div class="stk-page-sub">Értékesítés, profit és szállítási bontás időben — a rendelések és a kalkuláció adataiból.</div>
    </div>
    <div class="rip-controls">
      <div class="rip-tabs">
        <button type="button" class="rip-tab" *ngFor="let t of rangeTabs"
                [class.rip-tab--active]="range === t" (click)="setRange(t)">{{ t }}</button>
      </div>
      <div class="rip-select-wrap">
        <select class="rip-select" [(ngModel)]="shop" (ngModelChange)="onFilterChange()">
          <option *ngFor="let o of shopOptions" [ngValue]="o.value">{{ o.label }}</option>
        </select>
        <span class="rip-select-chevron">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
        </span>
      </div>
      <div class="rip-select-wrap">
        <select class="rip-select" [(ngModel)]="country" (ngModelChange)="onFilterChange()">
          <option *ngFor="let o of countryOptions" [ngValue]="o.value">{{ o.label }}</option>
        </select>
        <span class="rip-select-chevron">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
        </span>
      </div>
      <div class="rip-dates" *ngIf="isCustom">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="1.8" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="2"></rect><line x1="3" y1="10" x2="21" y2="10"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="16" y1="3" x2="16" y2="7"></line></svg>
        <input type="date" [(ngModel)]="customFrom" (ngModelChange)="onCustomDateChange()">
        <span class="rip-dates__sep">–</span>
        <input type="date" [(ngModel)]="customTo" (ngModelChange)="onCustomDateChange()">
      </div>
    </div>
  </div>

  <!-- Hiba állapot -->
  <div class="rip-state" *ngIf="loadFailed">
    <div class="rip-state__icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#707870" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="11" x2="12" y2="16"></line><circle cx="12" cy="8" r="0.4" fill="#707870"></circle></svg>
    </div>
    <div class="rip-state__title">A riport adatok nem érhetők el</div>
    <div class="rip-state__sub">A rendelés-összesítő nem válaszol — próbáld meg később újra.</div>
    <button type="button" class="stk-btn stk-btn--ghost rip-state__btn" (click)="reload()">Újrapróbálás</button>
  </div>

  <!-- Betöltés -->
  <div class="rip-state" *ngIf="loading && !loadFailed">
    <div class="rip-state__sub">Riport adatok betöltése…</div>
  </div>

  <ng-container *ngIf="!loading && !loadFailed">

    <!-- KPI kártyák -->
    <div class="rip-kpis">
      <div class="rip-kpi" *ngFor="let k of kpis">
        <div class="rip-kpi__head">
          <span class="rip-kpi__icon">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" [ngSwitch]="k.icon">
              <ng-container *ngSwitchCase="'sales'">
                <line x1="4" y1="19" x2="20" y2="19"></line>
                <polyline points="5,15 10,9 14,13 20,6"></polyline>
              </ng-container>
              <ng-container *ngSwitchCase="'profit'">
                <circle cx="12" cy="12" r="8.5"></circle>
                <path d="M14.5 9.3 a3 3 0 1 0 0 5.4"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'orders'">
                <polyline points="3,4 6,4 8.4,14.5 18.6,14.5 20.6,7.5 7.2,7.5"></polyline>
                <circle cx="9.4" cy="19" r="1.5"></circle>
                <circle cx="17.4" cy="19" r="1.5"></circle>
              </ng-container>
              <ng-container *ngSwitchCase="'basket'">
                <rect x="4" y="7" width="16" height="13" rx="2"></rect>
                <path d="M8 7 V5 a4 4 0 0 1 8 0 V7"></path>
              </ng-container>
            </svg>
          </span>
          <span class="rip-kpi__label">{{ k.label }}</span>
        </div>
        <div class="rip-kpi__value">{{ k.value }}</div>
        <div class="rip-kpi__delta"
             [class.rip-kpi__delta--down]="k.tone === 'down'"
             [class.rip-kpi__delta--muted]="k.tone === 'muted'">{{ k.delta }}</div>
      </div>
    </div>

    <!-- Eladás + profit grafikon -->
    <div class="rip-card rip-chart-card">
      <div class="rip-chart-head">
        <h3 class="rip-chart-title">Értékesítés és profit · {{ rangeLabel }}</h3>
        <div class="rip-legend">
          <span class="rip-legend__line rip-legend__line--sales"></span>
          <span class="rip-legend__label">Értékesítés</span>
        </div>
        <div class="rip-legend">
          <span class="rip-legend__line rip-legend__line--profit"></span>
          <span class="rip-legend__label">Profit</span>
        </div>
      </div>
      <div class="rip-chart-wrap" *ngIf="chart">
        <div class="rip-chart-empty" *ngIf="chartEmpty">Nincs értékesítés a kiválasztott időszakban.</div>
        <svg class="rip-chart" viewBox="0 0 920 300">
          <ng-container *ngFor="let g of chart.grid">
            <line x1="56" [attr.y1]="g.y" x2="900" [attr.y2]="g.y"
                  [attr.stroke]="g.base ? '#E4E7DD' : '#F2F4EC'" stroke-width="0.75"></line>
            <text class="rip-chart__ytick" x="46" [attr.y]="g.y + 4" text-anchor="end">{{ g.label }}</text>
          </ng-container>

          <path [attr.d]="chart.salesPath" fill="none" stroke="#8FB859" stroke-width="1.2" stroke-linejoin="round" stroke-linecap="round"></path>
          <path *ngIf="chart.profitPath" [attr.d]="chart.profitPath" fill="none" stroke="#17191C" stroke-width="1" stroke-linejoin="round" stroke-linecap="round"></path>

          <circle *ngFor="let d of chart.salesDots" [attr.cx]="d.x" [attr.cy]="d.y" r="2" fill="#FFFFFF" stroke="#8FB859" stroke-width="1.2"></circle>
          <circle *ngFor="let d of chart.profitDots" [attr.cx]="d.x" [attr.cy]="d.y" r="2" fill="#FFFFFF" stroke="#17191C" stroke-width="1.2"></circle>

          <ng-container *ngIf="chart.last && hoverIdx === null">
            <circle [attr.cx]="chart.last.x" [attr.cy]="chart.last.ys" r="3" fill="#8FB859" stroke="#FFFFFF" stroke-width="1.5"></circle>
            <circle *ngIf="chart.last.yp !== null" [attr.cx]="chart.last.x" [attr.cy]="chart.last.yp" r="2.8" fill="#17191C" stroke="#FFFFFF" stroke-width="1.5"></circle>
          </ng-container>

          <text *ngFor="let t of chart.salesLabels" class="rip-chart__vlabel rip-chart__vlabel--sales" [attr.x]="t.x" [attr.y]="t.y" text-anchor="middle">{{ t.text }}</text>
          <text *ngFor="let t of chart.pctLabels" class="rip-chart__vlabel" [attr.x]="t.x" [attr.y]="t.y" text-anchor="middle">{{ t.text }}</text>
          <text *ngFor="let t of chart.xLabels" class="rip-chart__xtick" [attr.x]="t.x" [attr.y]="t.y" text-anchor="middle">{{ t.text }}</text>

          <!-- hover crosshair + tooltip -->
          <ng-container *ngIf="tooltip">
            <line [attr.x1]="tooltip.x" y1="30" [attr.x2]="tooltip.x" y2="266" stroke="#C9CEC0" stroke-width="0.75"></line>
            <circle [attr.cx]="tooltip.x" [attr.cy]="tooltip.sy" r="3.2" fill="#8FB859" stroke="#FFFFFF" stroke-width="1.5"></circle>
            <circle *ngIf="tooltip.py !== null" [attr.cx]="tooltip.x" [attr.cy]="tooltip.py" r="3" fill="#17191C" stroke="#FFFFFF" stroke-width="1.5"></circle>
            <g>
              <rect [attr.x]="tooltip.tx" [attr.y]="tooltip.ty" width="132" height="66" rx="9" fill="#17191C" opacity="0.96"></rect>
              <text class="rip-chart__tt-title" [attr.x]="tooltip.tx + 12" [attr.y]="tooltip.ty + 19">{{ tooltip.label }}</text>
              <text class="rip-chart__tt-sales" [attr.x]="tooltip.tx + 12" [attr.y]="tooltip.ty + 37">{{ tooltip.salesText }}</text>
              <text class="rip-chart__tt-profit" [attr.x]="tooltip.tx + 12" [attr.y]="tooltip.ty + 53">{{ tooltip.profitText }}</text>
            </g>
          </ng-container>

          <rect *ngFor="let hit of chart.hits; let i = index" [attr.x]="hit.x" y="30" [attr.width]="hit.w" height="236"
                fill="transparent" (mouseenter)="setHover(i)" (mouseleave)="setHover(null)"></rect>
        </svg>
      </div>
    </div>

    <div class="rip-grid">

      <!-- Rendelések ország szerint -->
      <div class="rip-card">
        <h3 class="rip-sec-title">Rendelések ország szerint</h3>
        <div class="rip-country-list">
          <div *ngFor="let c of countries">
            <div class="rip-country__row">
              <span class="rip-country__name">{{ c.name }}</span>
              <span class="rip-country__spacer"></span>
              <span class="rip-country__count">{{ c.orders }} db</span>
              <span class="rip-country__pct">{{ c.pct }}</span>
            </div>
            <div class="rip-bar">
              <div class="rip-bar__fill" [style.width.%]="c.width"></div>
            </div>
          </div>
          <div class="rip-empty" *ngIf="countriesEmpty">Nincs rendelés a kiválasztott időszakban.</div>
        </div>
      </div>

      <!-- Szállítás ország szerint -->
      <div class="rip-card">
        <h3 class="rip-sec-title rip-sec-title--tight">Szállítás ország szerint</h3>
        <div class="rip-ship-sub">Átlagos szállítási költség / rendelés</div>
        <div class="rip-ship-list">
          <div class="rip-ship-row" *ngFor="let s of shipRows">
            <span class="rip-ship-cc">{{ s.code }}</span>
            <div class="rip-bar rip-ship-bar">
              <div class="rip-bar__fill rip-bar__fill--ship" [style.width.%]="s.width"></div>
            </div>
            <span class="rip-ship-avg">{{ s.avg }}</span>
          </div>
          <div class="rip-empty" *ngIf="shipEmpty">Még nincs szállítási költség adat az időszakra.</div>
        </div>
      </div>

    </div>

    <!-- Legjövedelmezőbb termékek -->
    <div class="rip-top">
      <div class="rip-top__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 21 h8"></path><path d="M12 17 v4"></path><path d="M6 3 h12 v6 a6 6 0 0 1 -12 0 Z"></path><path d="M6 5 H3 a3 3 0 0 0 3 5"></path><path d="M18 5 h3 a3 3 0 0 1 -3 5"></path></svg>
        <h3 class="rip-top__title">Legjövedelmezőbb termékek · termék + ország bontás</h3>
        <span class="rip-top__hint">díjak, szállítás és vám levonása után</span>
      </div>
      <div class="rip-top__scroll">
        <div class="rip-top__row rip-top__row--head">
          <div class="rip-top__th">#</div>
          <div class="rip-top__th">Termék</div>
          <div class="rip-top__th">Ország</div>
          <div class="rip-top__th rip-top__th--right">Eladott</div>
          <div class="rip-top__th rip-top__th--right">Árbevétel</div>
          <div class="rip-top__th">Levonások / db</div>
          <div class="rip-top__th rip-top__th--right">Profit</div>
          <div class="rip-top__th">Árrés</div>
        </div>
        <div class="rip-top__row" *ngFor="let r of topRows">
          <div class="rip-top__rank" [class.rip-top__rank--first]="r.first">{{ r.rank }}</div>
          <div class="rip-top__prod-cell">
            <div class="rip-top__prod">{{ r.prod }}</div>
            <div class="rip-top__shop">{{ r.shop }}</div>
          </div>
          <div><span class="rip-top__cc">{{ r.country }}</span></div>
          <div class="rip-top__qty">{{ r.qty }} db</div>
          <div class="rip-top__rev">{{ r.revenue }}</div>
          <div class="rip-top__cost">{{ r.costLabel }}</div>
          <div class="rip-top__profit" [class.rip-top__profit--neg]="r.neg">{{ r.profit }}</div>
          <div class="rip-top__margin">
            <div class="rip-top__mbar">
              <div class="rip-top__mfill" [ngClass]="'rip-top__mfill--' + r.tone" [style.width.%]="r.width"></div>
            </div>
            <span class="rip-top__mpill" [ngClass]="'rip-top__mpill--' + r.tone">{{ r.margin }}</span>
          </div>
        </div>
        <div class="rip-top__empty" *ngIf="topEmpty">Nincs adat a kiválasztott szűréshez.</div>
      </div>
      <div class="rip-top__note">{{ topNote }}</div>
    </div>

  </ng-container>

</div>
